import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemText, CircularProgress, Typography } from '@material-ui/core';
import { BASE_URL, DATA_USER } from '../../../../constants/constants';

const LoginHistoryModal = ({ open, onClose, userId, pageSize = 10 }) => {
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (!open) return;
        setLoading(true);
        const tokenObj = localStorage.getItem(DATA_USER);
        let token = null;
        if (tokenObj) {
            try { token = JSON.parse(tokenObj).token } catch (e) { }
        }
        const url = `${BASE_URL}/api/user/${userId}/login-history?page=${page}&maxPerPage=${pageSize}`;
        fetch(url, {
            headers: token ? { 'Authorization': `Bearer ${token}` } : {}
        }).then(res => res.json()).then(json => {
            setItems(json.items || []);
            setTotal(json.nbResults || 0);
        }).catch(err => {
            console.error(err);
        }).finally(() => setLoading(false));
    }, [open, userId, page, pageSize]);

    const nbPages = Math.ceil(total / pageSize) || 1;

    return (
        <Dialog open={!!open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Login history</DialogTitle>
            <DialogContent>
                {loading && <CircularProgress />}
                {!loading && items.length === 0 && <Typography>No history</Typography>}
                {!loading && items.length > 0 && (
                    <List>
                        {items.map(item => (
                            <ListItem key={item.id} divider>
                                <ListItemText
                                    primary={`${item.createdAt} — ${item.ip} — ${item.device} / ${item.browser} ${item.browserVersion || ''}`}
                                    secondary={`UA: ${item.userAgent || ''} · lang: ${item.acceptLanguage || ''}`}
                                />
                            </ListItem>
                        ))}
                    </List>
                )}
            </DialogContent>
            <DialogActions>
                <div style={{ flex: 1, textAlign: 'left', paddingLeft: 16 }}>
                    {nbPages > 1 && (
                        <React.Fragment>
                            <Button disabled={page <= 1} onClick={() => setPage(page - 1)}>{'<'}</Button>
                            <Button disabled>{page}</Button>
                            <Button disabled={page >= nbPages} onClick={() => setPage(page + 1)}>{'>'}</Button>
                        </React.Fragment>
                    )}
                </div>
                <Button onClick={onClose} color="primary">Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default LoginHistoryModal;
